import { ComponentsProps, ComponentsOverrides, ComponentsVariants } from '@mui/material';
import { Theme } from '@mui/material';

export const ButtonTheme = (): {
  defaultProps?: ComponentsProps['MuiButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiButton'];
  variants?: ComponentsVariants['MuiButton'];
} => {
  return {
    defaultProps: {
      disableElevation: true,
      variant: 'contained'
    },
    styleOverrides: {
      root: () => ({
        textTransform: 'none',
        borderRadius: 24,
        fontSize: '14px',
        lineHeight: '20px',
        minHeight: '40px'
      }),
      contained: ({ theme }) => ({
        '&:hover': {
          boxShadow: theme.shadows[4]
        }
      }),
      outlined: ({ theme }) => ({
        '&:hover': {
          boxShadow: theme.shadows[1]
        }
      })
      // containedPrimary: ({ theme }) => ({
      //   backgroundColor: theme.palette.primary.light,
      //   '&:disabled': {
      //     opacity: 0.5
      //   }
      // }),
      // containedError: ({theme}) => ({
      //   backgroundColor: theme.palette.error.light,
      //   color: theme.palette.error.main
      // })
    }
  };
};
